import { createStore } from 'vuex'

import { activities } from '@/store/activities/index.js'
import { categories } from '@/store/categories/index.js'
import { navigation } from '@/store/navigation/index.js'
import { seo } from '@/store/seo/index.js'

const createSlugMap =
  (typeKey) =>
  ({ beet }) => {
    const data = beet.data[typeKey] || {}
    return Object.values(data).reduce((slugMap, { id, slug }) => ({ ...slugMap, [slug]: id }), {})
  }

export default createStore({
  getters: {
    activitiesSlugMap: createSlugMap('activities'),
    categoriesSlugMap: createSlugMap('categories'),
  },
  modules: {
    activities,
    categories,
    navigation,
    seo,
  },
})
